<div fxLayout="column">
	<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
	<form [formGroup]="questionnaireForm" fxLayout="row" fxLayout.lt-md="column" fxFill>
		<div fxFlex="50"
			 fxLayout="column"
			 fxLayoutAlign="space-around stretch"
			 class="element-container"
			 id="user-section">
			<div fxLayout="row" fxLayoutAlign="center center">
				<img src="assets/images/users.svg">
			</div>
			<h3>{{today | date:'EEEE d MMMM y'}}</h3>
			<mat-form-field>
				<mat-label>Nombre:</mat-label>
				<input matInput formControlName="name" type="text">
				<mat-error *ngIf="form.name.errors ?.required">Nombre
					<strong>Requerido</strong>
				</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label>Empresa o razón social:</mat-label>
				<input matInput formControlName="nameCompany" type="text">
				<mat-error *ngIf="form.nameCompany.errors ?.required">Empresa
					<strong>Requerido</strong>
				</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label>Cargo:</mat-label>
				<input matInput formControlName="position" type="text">
				<mat-error *ngIf="form.position.errors ?.required">Cargo
					<strong>Requerido</strong>
				</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label>Correo electrónico:</mat-label>
				<input matInput formControlName="email" type="email">
				<mat-error *ngIf="form.email.errors ?.required">Email
					<strong>Requerido</strong>
				</mat-error>
				<mat-error *ngIf="form.email.errors ?.email">Email
					<strong>Invalido</strong>
				</mat-error>
			</mat-form-field>
		</div>
		<div fxFlex="50"
			 fxLayout="column"
			 fxLayoutAlign="space-around stretch"
			 class="element-container"
			 id="company-section">
			<div fxLayout="row" fxLayoutAlign="center center">
				<img src="assets/images/company.svg">
			</div>
			<mat-form-field>
				<mat-label>Entidad federativa:</mat-label>
				<mat-select formControlName="state">
					<mat-option
						*ngFor="let repStates of catalogs.states | keyvalue: valueOrder"
						[value]="repStates.key">
						{{repStates.value}}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="form.state.errors ?.required">Entidad <strong>Requerido</strong>
				</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label>Sector económico:</mat-label>
				<mat-select formControlName="economicSector">
					<mat-option
						*ngFor="let economicSector of catalogs.economicSectors.values"
						[value]="economicSector">
						{{catalogs.economicSectors.strings[economicSector]}}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="form.economicSector.errors ?.required">Sector Economico
					<strong>Requerido</strong>
				</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label>Actividad empresarial:</mat-label>
				<mat-select formControlName="businessActivity">
					<mat-option
						*ngFor="let bussiness of catalogs.businessActivities.values"
						[value]="bussiness">
						{{catalogs.businessActivities.strings[bussiness]}}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="form.businessActivity.errors ?.required">
					Actividad Empresarial<strong>Requerido</strong>
				</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label>Tamaño de la empresa:</mat-label>
				<mat-select formControlName="size">
					<mat-option
						*ngFor="let sizes of catalogs.companySizes.values"
						[value]="sizes">
						{{catalogs.companySizes.strings[sizes]}}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="form.size.errors ?.required">
					Tamaño<strong>Requerido</strong>
				</mat-error>
			</mat-form-field>
			<p>
				¿Qué recursos, bienes o servicios adquiridos representan el mayor costo
				en la empresa?, ¿en qué porcentaje?
			</p>
			<div fxLayout="column" fxLayoutAlign="space-around stretch">
				<div fxLayout="row" fxLayoutAlign="center center">
					<span>Servicios externos:</span>
					<mat-slider
						thumbLabel
						[displayWith]="formatLabel"
						tickInterval="100"
						step="5"
						min="1"
						max="100"
						formControlName="services" type="number" min="0" max="100">
					</mat-slider>
				</div>
				<div fxLayout="row" fxLayoutAlign="center center">
					<span>Bienes:</span>
					<mat-slider
						thumbLabel
						[displayWith]="formatLabel"
						tickInterval="100"
						step="5"
						min="1"
						max="100"
						formControlName="goods" type="number" min="0" max="100">
					</mat-slider>
				</div>
				<div fxLayout="row" fxLayoutAlign="center center">
					<span>Recursos naturales y materiales:</span>
					<mat-slider
						thumbLabel
						[displayWith]="formatLabel"
						tickInterval="100"
						step="5"
						min="1"
						max="100"
						formControlName="resources" type="number" min="0" max="100">
					</mat-slider>
				</div>
			</div>
			<div fxLayout="row" fxFlexAlign="end">
				<button mat-raised-button color="primary"
						[disabled]="!questionnaireForm.valid || isLoading"
						(click)="sendData()">Guardar
				</button>
			</div>
		</div>
	</form>
	<app-footer></app-footer>
</div>
